module.exports = __webpack_public_path__ + "img/step02_a_stand_basic_position_both_feet.5d3e5985.png";